import { useState, useContext } from "react";
import landingStyle from "../styles/landing.module.scss";
import LoginFunction, {
  fetchUserByIdentifier,
  isPasswordRequiredForUser,
  isPasswordlessLoginIdentifier,
} from "../utilities/LoginFunction";
import { UserContext } from "../context/UserContext";
import useToken from "../utilities/hooks/useToken";
import { useNavigate } from "react-router-dom";

const ASIATAN_LOGO = "/images/asiatanLogo.png";
const TECTUFF_LOGO = "/images/tectuffLogo.png";

function LoginForm() {
  const { changeUserInformation, userInformation, changelogOutUser } =
    useContext(UserContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [requiresPassword, setRequiresPassword] = useState(false);
  const { setToken } = useToken();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  //let [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleLogOutUser = () => {
    changelogOutUser();
  };

  const normalizeLoginIdentifier = (value) => value.trim().toLowerCase();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const loginIdentifier = normalizeLoginIdentifier(email);

    if (!loginIdentifier) {
      setMessage("Enter your email or ID");
      return;
    }

    setLoading(true);
    const account = await fetchUserByIdentifier(loginIdentifier);

    if (!account) {
      setMessage("account not found");
      setLoading(false);
      return;
    }

    const passwordNeeded = isPasswordRequiredForUser(account);
    setRequiresPassword(passwordNeeded);

    if (passwordNeeded && !password.trim()) {
      setMessage("Password is required for this account");
      setLoading(false);
      return;
    }

    const response = await LoginFunction(
      loginIdentifier,
      passwordNeeded ? password : "",
      { includePassword: passwordNeeded },
    );

    if (response?.error) {
      setMessage(response.message || "Unable to sign in");
      setLoading(false);
      return;
    }

    if (response?.id) {
      setToken(response.accessToken);
      if (response.accessToken?.length > 20) {
        changeUserInformation({
          userId: response.id,
          userType: response.userType,
          vendor: response.brand,
          userName: response.userName,
          isLoggedIn: true,
        });
        navigate("/library");
      }

      setMessage("");
      setLoading(false);
      return;
    }

    setMessage("account not found");
    setLoading(false);
  };

  const inputField = (e) => {
    const nextValue = e.target.value;
    setEmail(nextValue);
    setMessage("");
    setRequiresPassword(!isPasswordlessLoginIdentifier(nextValue));
  };
  const passwordField = (e) => {
    setPassword(e.target.value);
    setMessage("");
  };

  const { isLoggedIn, userName } = userInformation;

  if (userName && isLoggedIn) {
    return (
      <div className={landingStyle.sessionPanel}>
        <div className={landingStyle.vendorLogos}>
          <img src={ASIATAN_LOGO} alt="asiatan" />
          <img src={TECTUFF_LOGO} alt="tectuff" />
        </div>
        <div className={landingStyle.loginViewContent}>
          <p className={landingStyle.stateLabel}>Current Session</p>
          <h3 className={landingStyle.loginViewHeading}>
            You are currently logged in as {userInformation.userName} from{" "}
            {userInformation.vendor}
          </h3>
          <div className={landingStyle.sessionActionGroup}>
            <button
              className="button-highlight"
              onClick={() => navigate("/library")}
            >
              go to Library
            </button>
            <button className="button-highlight" onClick={handleLogOutUser}>
              Log out
            </button>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={landingStyle.loginView}>
      <div className={landingStyle.vendorLogos}>
        <img src={ASIATAN_LOGO} alt="asiatan" />
        <img src={TECTUFF_LOGO} alt="tectuff" />
      </div>
      <form className={landingStyle.loginForm} onSubmit={handleSubmit}>
        <div className={landingStyle.formHeader}>
          <p className={landingStyle.stateLabel}>Sign In</p>
          <h3>Welcome back</h3>
          <p>Sign in with your email or ID.</p>
        </div>

        <div className={landingStyle.loginInputGroup}>
          <label htmlFor="email">Email or ID</label>
          <input
            id="email"
            name="email"
            type="text"
            placeholder="Email or ID"
            autoComplete="username"
            value={email}
            onChange={inputField}
          />
          {requiresPassword && email.trim() ? (
            <>
              <label htmlFor="password">Password</label>
              <input
                id="password"
                name="password"
                type="password"
                placeholder="Enter password"
                autoComplete="new-password"
                value={password}
                onChange={passwordField}
              />
            </>
          ) : null}
          {message !== "" ? (
            <div className={landingStyle.loginErrorMessage}>{message}</div>
          ) : null}
        </div>
        {loading ? (
          <div className={landingStyle.loginLoading} aria-live="polite">
            <div className={landingStyle.loadingDots} aria-hidden="true">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <span className={landingStyle.loadingLabel}>Checking access</span>
          </div>
        ) : null}
        <button
          className={`${landingStyle.button} ${!email.trim() ? landingStyle.buttonDisabled : ""}`}
          type="submit"
          disabled={!email.trim()}
        >
          {loading ? "Signing in..." : "Login"}
        </button>
      </form>
    </div>
  );
}

export default LoginForm;
